import React, { useEffect } from "react";
import {
  Box,
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
  VStack,
} from "@chakra-ui/react";
import { LanguageSelector } from "./LanguageSelector";
import { useTranslationContext } from "../../hooks/translation-context";
import { Progress } from "./Progress";
import { generateHeaders, platform } from "../../config/graphql";
import { Event } from "../../types/events";
import { useAuthContext } from "../../hooks/auth-context";
import { registerEvent } from "../../utils/events";

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

export const TranslationModal: React.FC<Props> = ({ isOpen, onClose }) => {
  const {
    ready,
    progress,
    sourceLanguage,
    targetLanguage,
    // setSourceLanguage,
    setTargetLanguage,
    enqueueTranslate: translate,
    stopTranslation,
    error,
  } = useTranslationContext();

  const { auth } = useAuthContext();

  useEffect(() => {
    if (!progress || progress.length === 0) {
      onClose();
    }
  }, [progress, onClose]);

  const translationHandler = async () => {
    const headers = generateHeaders({
      token: auth?.token || "",
    });
    const event: Event = {
      event: "website_translation",
      event_type: "translation",
      user_id: auth?.user?.id,
      organization_id: auth?.user?.organization.id,
      req_data: JSON.stringify({
        operationName: "wellbeing_resources",
        variables: {
          sourceLanguage,
          targetLanguage,
          page_title_translated: document.title,
          page_url_translated: window.location.href,
        },
      }),
      other: JSON.stringify({
        platform: platform,
        timestamp: new Date().toISOString(),
      }),
    };
    translate();
    registerEvent(event, headers).catch((err) =>
      console.error("registerEventForWebsiteTranslation error:", err),
    );
    if (ready) {
      onClose();
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size="lg">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Translate Website</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack spacing={4} align="stretch">
            <Text fontSize="sm" fontWeight="hairline" textAlign="justify">
              Please note that this is an experimental feature, and translation
              may take a few minutes. Changes will appear in real time.
            </Text>
            {/* <Box>
              <LanguageSelector
                label="Source"
                value={sourceLanguage}
                onChange={setSourceLanguage}
              />
            </Box> */}
            <Box>
              <LanguageSelector
                label=""
                value={targetLanguage}
                onChange={setTargetLanguage}
              />
            </Box>

            {error ? (
              <Text color="red.500" fontSize="sm">
                {error}
              </Text>
            ) : (
              progress.map((p, index) => (
                <Progress
                  key={String(p.file) + index}
                  text={String(p.file)}
                  percentage={Number(p.progress)}
                />
              ))
            )}

            <HStack mt={2} mb={5} justifyContent="space-between">
              <Button w="full" onClick={translationHandler}>
                Translate
              </Button>
              <Button w="full" variant="outline" onClick={stopTranslation}>
                Stop
              </Button>
            </HStack>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
